import React from "react"
import IconPopUpChevron from "../icons/iconPopUpChevron.svg"

export default function FormInput(props) {
  const { content } = props
  switch(content) {
    case 'selection':
      return (
        <label className={`formInput ${props.size} ${ props.hierarchy } ${ props.content } ${ props.state }`}>
          <div className="formInputTitle">{props.title}</div>
          
          <div className="formInputValueContainer">
            <select className="formInputValue" name={props.name}>
              {props.options}
            </select>

            <IconPopUpChevron className="popUpIcon" />

            <div className="formInputValueHighlight" />
          </div>
          <div className="formInputHighlight" />
        </label>
      )
    default:
      return (
        <label className={`formInput ${props.size} ${ props.hierarchy } ${ props.content } ${ props.state }`}>
          <div className="formInputTitle">{props.title}</div>
          
          <div className="formInputValueContainer">
            <input className="formInputValue" type={props.type} name={props.name} placeholder={props.placeholder} />
            <div className="formInputValueHighlight" />
          </div>
          <div className="formInputHighlight" />
        </label>
      )
  }
}
